import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { LayoutService } from 'src/app/services/layout.service';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { PlanogramService } from 'src/app/services/planogram.service';
import { ToastService } from 'src/app/services/toasts.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-save-modal',
    templateUrl: './save-modal.component.html',
    styleUrls: ['./save-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule]
})
export class SaveModalComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  saveName: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private toastService: ToastService,
    private planogramService: PlanogramService,
    private layoutService: LayoutService,
    private planogramApiService: PlanogramApiService
  ) {}

  ngOnInit(): void {
    this.saveName = `${this.planogramService.getStoreName()} - ${this.planogramService.getMerchName()}`
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async confirm(): Promise<void> {
    if(this.saveName.length == 0){
      this.toastService.show('Please enter a name for the planogram.', {
        classname: `bg-danger text-light p-3 fs-5`,
        delay: 3000
      });
      return;
    }
    
    this.planogramApiService.savePlanogram(this.planogramService.getPlanogramState(), this.saveName, true)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (stateId: string | null) => {
          if (stateId) {
            this.planogramService.setPlanogramState(stateId);
            this.layoutService.clearHistory();
            this.activeModal.close();
          } else {
            this.toastService.show('Failed to save planogram', {
              classname: `bg-danger text-light p-3 fs-5`,
              delay: 3000
            });
          }
        },
        error: (error) => {
          console.error('Error saving planogram:', error);
          this.activeModal.close();
        }
      });
  }


  cancel(): void{
    this.activeModal.close(null);
  }
}
